export default function R_Vectors() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Vectors Component</h1>
      <p>This is the R_Vectors tutorial section.</p>
    </div>
  );
}
